import { observer } from "mobx-react-lite";
import { useContext, useEffect, useRef, useState } from "react";
import Clicker from "../ui/Clicker";
import TableBlock from "./tableBlock";
import AutoTextArea from "../ui/AutoTextArea";
import { ReactComponent as RemoveIcon } from "../../images/icons/contextRemove.svg"
import useNotification from "../../hooks/useNotification";
import { Context } from "../..";

const TableRow = ({ value, setValue, saveValue, onDelete, index, isNew, selectionMode, changeSelection, selectionList }) => {
    const { store } = useContext(Context);
    const { error } = useNotification();
    const rowRef = useRef(null);
    const inputRef = useRef(null);
    const [editMode, setEditMode] = useState(isNew ? true : false);
    const [isRemove, setRemove] = useState(false);

    useEffect(() => {
        if (isNew && inputRef.current && store.userInfo && store.userInfo.isLicensed == true) {
            setEditMode(true);
            inputRef.current.focus();
        }
    }, []);
    useEffect(() => {
        if (editMode && inputRef.current) {
            inputRef.current.focus();
        }
    }, [editMode]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (rowRef.current && !rowRef.current.contains(event.target) && event.target.id != "notificationButton") {
                save();
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [value, editMode]);

    function save() {
        if (!editMode) return;
        if (!inputRef.current) return;
        inputRef.current.blur();

        const confirmSave = () => {
            setEditMode(false);
            saveValue(value);
        }

        const handleNewItem = () => {
            if (value.interval == 1 && 
                value.osno == 0 && 
                value.usn_d == 0 && 
                value.usn_dr == 0 && 
                value.vat_five == 0 && 
                value.vat_twenty == 0
            ) {
                if (!validateFields()) onDelete();
                else confirmSave();
            } else {
                if (validateFields(true)) confirmSave();
            }
        }

        if (!isNew && validateFields(true)) confirmSave();
        else if (isNew) handleNewItem();
    }
    const validateFields = (showError) => {
        if (value.name.replace(" ", "") == "") {
            inputRef.current.className = "error";
            if (showError) error('Поле "Наименование" не может быть пустым', { showBtns: false });
            return false;
        }
        inputRef.current.className = "";
        return true;
    }

    let timeoutRemove;
    const remove = () => {
        if (isRemove === true) return;
        setRemove(true);
        if (isNew) {
            onDelete();
            return;
        }
        timeoutRemove = setTimeout(() => setRemove(false), 3000); 
    }
    const confirmRemove = () => {
        if (isRemove === false) return;
        clearTimeout(timeoutRemove);
        setRemove(false);
        onDelete();
    }

    return (
        // <li 
        //      ref={rowRef} 
        //      onBlur={handleBlur} 
        //      onContextMenu={onContextMenu} 
        //      className={editMode ? "active" : ""}
        //  >
        <li 
            ref={rowRef} 
            className={`${editMode ? "active" : ""}${isRemove?" remove":""}`}
            onClick={(event) => {
                if (!store.userInfo || !store.userInfo.isLicensed || store.userInfo.isLicensed == false) return;
                if (!selectionMode) return;
                event.preventDefault();
                changeSelection(value.id);
            }}
        >
            <div className="num" style={{ cursor: "pointer" }}>{index+1}. {selectionMode && <input 
                type="checkbox" 
                checked={selectionList && selectionList.includes(value.id)}
                onChange={(event) => {}}
                style={{ pointerEvents: "none" }}
            />}</div>
            <div className="name">
                <div className="text" style={{ cursor: "pointer" }} onClick={() => selectionMode === false && store.userInfo && store.userInfo.isLicensed == true && setEditMode(true)}>
                    {editMode 
                        ? 
                        <AutoTextArea 
                            ref={inputRef}
                            active={editMode} 
                            value={value.name} 
                            setValue={(newValue) => setValue(newValue, "name")}
                            save={save}
                        />
                        : value.name 
                    }
                </div>
                {/* <ul className="tags"></ul> */}
            </div>
            <div className="attrs">
                <div className="tdContainer">
                    <Clicker 
                        value={value.interval} 
                        setValue={(newValue) => {
                            setValue(newValue, "interval")
                            if (!editMode) saveValue({ ...value, interval: newValue });
                        }} 
                        disabled={selectionMode || !store.userInfo || store.userInfo.isLicensed == false ? true : false}
                        max={12}
                        isDecimal={true}
                        step={1}
                    />
                </div>
                <TableBlock save={save} disabled={selectionMode || !store.userInfo || store.userInfo.isLicensed == false ? true : false} value={value.usn_d} setValue={(newValue) => {
                    setValue(newValue, "usn_d");
                    if (!editMode) saveValue({ ...value, usn_d: newValue });
                }}/>
                <TableBlock save={save} disabled={selectionMode || !store.userInfo || store.userInfo.isLicensed == false ? true : false} value={value.usn_dr} setValue={(newValue) => {
                    setValue(newValue, "usn_dr");
                    if (!editMode) saveValue({ ...value, usn_dr: newValue });
                }}/>
                <TableBlock save={save} disabled={selectionMode || !store.userInfo || store.userInfo.isLicensed == false ? true : false} value={value.vat_twenty} setValue={(newValue) => {
                    setValue(newValue, "vat_twenty");
                    if (!editMode) saveValue({ ...value, vat_twenty: newValue });
                }}/>
                <TableBlock save={save} disabled={selectionMode || !store.userInfo || store.userInfo.isLicensed == false ? true : false} value={value.vat_five} setValue={(newValue) => {
                    setValue(newValue, "vat_five");
                    if (!editMode) saveValue({ ...value, vat_five: newValue });
                }}/>
                <TableBlock save={save} disabled={selectionMode || !store.userInfo || store.userInfo.isLicensed == false ? true : false} value={value.osno} setValue={(newValue) => {
                    setValue(newValue, "osno");
                    if (!editMode) saveValue({ ...value, osno: newValue });
                }}/>
                <button 
                    className="remove"
                    onClick={() => {
                        if (!store.userInfo || store.userInfo.isLicensed == false) return;
                        if (isRemove === false) remove();
                        else confirmRemove();
                    }}
                >
                    <RemoveIcon/>
                </button>
            </div>
        </li>
    );
}

export default observer(TableRow);
